import { render } from "./todayword.vue?vue&type=template&id=87797fd4"
import script from "./todayword.vue?vue&type=script&lang=js"
export * from "./todayword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__